<dt class="adm-data-point__label">{{ label() }}</dt>
<dd
  class="adm-data-point__value"
  [class.adm-data-point__value--mono]="mono()"
  [class.adm-data-point__value--accent]="accent()">
  @if (hasValue()) {
    {{ value() }}
  } @else {
    <span class="adm-data-point__empty" aria-label="no value">--</span>
  }
</dd>
